<script>
export default {
  name: 'CardNotes',
  props: {
    notes: {
      type: Array,
      required: true,
    },
  },
  computed: {
    interestNotes() {
      /* TODO сделать константу */
      return this.notes.length
        ? this.notes
        : ['Комментарий интересанта отсутствует']
    },
  },
}
</script>

<template>
  <div
    v-for="(note, idx) of interestNotes"
    :key="idx"
    class="flex p-2 rounded bg-amo-lead-feed"
  >
    {{ note }}
  </div>
</template>

<style>
.bg-amo-lead-feed {
  background-color: #f5f8fa;
}
</style>
